import React from 'react';
import { Tooltip } from 'carbon-components-react';
import { InformationFilled16 } from '@carbon/icons-react';

const InformationIcon = React.forwardRef(() => <InformationFilled16 />);
InformationIcon.displayName = 'InformationIcon';

export const LimitTooltip: React.FC<Props> = ({ align, direction }) => {
  return (
    <Tooltip
      align={align}
      className="sys-admin-org-limits-tooltip"
      direction={direction}
      renderIcon={InformationIcon}
    >
      Allocate resources for this organisation to manage teams and users
    </Tooltip>
  );
};

LimitTooltip.displayName = 'LimitTooltip';

export const TransactionLimitTooltip: React.FC<Props> = ({
  align,
  direction
}) => {
  return (
    <Tooltip
      align={align}
      className="sys-admin-org-limits-tooltip"
      direction={direction}
      renderIcon={InformationIcon}
    >
      Set the number of transactions, end date, and reference. Any enquiries
      exceeding the limit or made after the end date will not be viewable.
    </Tooltip>
  );
};

TransactionLimitTooltip.displayName = 'TransactionLimitTooltip';

type Props = {
  align?: 'center' | 'end' | 'start';
  direction?: 'bottom' | 'top' | 'left' | 'right';
};
